module.exports = __webpack_public_path__ + "static/media/superhero.34e26ea3.woff";